import { Box, CircularProgress, Grid } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import DashboardCalendar from '../../components/Calendar'
import Context from '../../context'
import { getDashData } from '../../services/ReportsApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'
import ParserComments from '../Dashboard/Helpers/ParserComents'

import CommentsItem from '../Dashboard/DashboardComments/components/CommentsItem'
import StyledTab from '../Dashboard/DashboardComments/components/StyledTab'
import StyledTabs from '../Dashboard/DashboardComments/components/StyledTabs'
import TabPanel from '../Dashboard/DashboardComments/components/TabPanel'
import useStyles from './styles'

function CommentsManagerPage() {
  const classes = useStyles()
  const { user, setUser, rangeDate, setRangeDate } = useContext(Context)
  const [isLoading, setIsLoading] = useState(false)
  const [value, setValue] = useState(1)
  const [publicCommentList, setPublicCommentList] = useState([])
  const [privateCommentList, setPrivateCommentList] = useState([])

  const updateData = () => {
    console.log('updateData')
    setIsLoading(true)

    getDashData(
      undefined,
      moment(rangeDate[0]).format('YYYY-MM-DD').toString(),
      moment(rangeDate[1]).format('YYYY-MM-DD').toString()
    ).then(r => {
      const { validations } = r

      setPublicCommentList(ParserComments('publicComment', validations))
      setPrivateCommentList(ParserComments('privateComment', validations))

      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }

    updateData()
  }, [])

  useEffect(() => {
    updateData()
  }, [rangeDate])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Grid container spacing={2}>
      <Context.Provider value={{ user, setUser, rangeDate, setRangeDate, setIsLoading }}>
        <Grid item sm={12}>
          <Grid container style={{ marginBottom: '25px', marginTop: '15px' }}>
            <Grid item xs={12} style={{ paddingLeft: '15px' }}>
              <h1>Comentários</h1>
            </Grid>

            {isLoading ? (
              <Grid item xs={8} style={{ padding: '15px' }}>
                <Grid className={classes.progressArea}>
                  <CircularProgress />
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={8} style={{ padding: '15px' }}>
                <Paper className={classes.tabArea}>
                  <StyledTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="styled tabs example"
                  >
                    <StyledTab label="COMENTÁRIOS" disabled />
                    <StyledTab label="PÚBLICOS" />
                    <StyledTab label="PRIVADOS" />
                  </StyledTabs>
                  <TabPanel value={value} index={1}>
                    {publicCommentList.length > 0 ? (
                      <>
                        {publicCommentList.map(item => (
                          <Box key={item.id}>
                            <CommentsItem data={item} showActions />
                          </Box>
                        ))}
                      </>
                    ) : (
                      <Paper elevation={3} style={{ height: '80px', padding: '10px' }}>
                        <h5>
                          Não foram encontrado dados entre{' '}
                          {moment(rangeDate[0]).format('DD/MM/YYYY').toString()} a{' '}
                          {moment(rangeDate[1]).format('DD/MM/YYYY').toString()}.
                        </h5>
                      </Paper>
                    )}
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    {privateCommentList.length > 0 ? (
                      <>
                        {privateCommentList.map(item => (
                          <div key={item.id}>
                            <CommentsItem key={item.id} data={item} />
                          </div>
                        ))}
                      </>
                    ) : (
                      <Paper elevation={3} style={{ height: '80px', padding: '10px' }}>
                        <h5>
                          Não foram encontrado dados entre{' '}
                          {moment(rangeDate[0]).format('DD/MM/YYYY').toString()} a{' '}
                          {moment(rangeDate[1]).format('DD/MM/YYYY').toString()}.
                        </h5>
                      </Paper>
                    )}
                  </TabPanel>
                </Paper>
              </Grid>
            )}

            <Grid item xs={4} style={{ height: '480px', marginTop: '15px' }}>
              <DashboardCalendar />
            </Grid>
          </Grid>
        </Grid>
      </Context.Provider>
    </Grid>
  )
}

export default CommentsManagerPage
